export { default } from './QRCodeMalaysia';
